var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"pageload"}},[(_vm.notFound)?_c('NotFound',{attrs:{"context":_vm.appState.sitecoreContext}}):_vm._e(),(_vm.redirecting)?_c('Redirecting',{attrs:{"context":_vm.appState.sitecoreContext}}):(_vm.loading)?_c('RouteLoading'):_c('Layout',{attrs:{"route":_vm.appState.routeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }